import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ViewComplainListSupport from "./viewComplainListSupport";
import {
  fetchComplainListL2Support,
} from "services/redux/fileComplain/action"

import {getRmTicketsFilterDropDown} from "services/redux/maintenance/rmTicket/action";

const mapStateToProps = (state) => ({
    complainList: state.fileComplainReducer.fetchComplainL2,
    rmTicketFilter: state.rmTicketReducer.rmTicketFilter
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    fetchComplainListL2Support,
    getRmTicketsFilterDropDown,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ViewComplainListSupport);
